module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleE.c8a7faa0.png";